import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {CheckboxOption} from "../../shared/model/select-option.model";

export class FilterModalParams {

  filters: Record<string, CheckboxOption[]> = {};

  constructor(filters: Record<string, CheckboxOption[]> = {}) {
    this.filters = filters;
  }

  /** true se almeno una chiave ha un array con elementi selezionati */
  hasActiveFilters(): boolean {
    return Object.values(this.filters).some(arr => arr.some(opt => opt.checked));
  }

  /** true se tutte le chiavi hanno array vuoti / nessun selezionato */
  isEmpty(): boolean {
    return Object.values(this.filters).every(arr => arr.length === 0);
  }

  reset(): void {
    Object.keys(this.filters).forEach(key => this.filters[key] = []);
  }

  uncheck(): void {
    Object.values(this.filters).forEach(arr =>
      arr.forEach(opt => opt.checked = false)
    );
  }

  countActiveKeys(): number {
    return Object.values(this.filters)
    .filter(arr => arr.some(opt => opt.checked))
      .length;
  }

}

@Component({
  selector: 'app-events-filter-modal',
  templateUrl: './events-filter-modal.component.html',
  styleUrls: ['./events-filter-modal.component.scss']
})
export class EventsFilterModalComponent  implements OnInit {

  @Input() params: FilterModalParams;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    console.log(this.params);
  }

  onClose(){
    this.modalCtrl.dismiss({
      skip: true
    });
  }

  onResetFiltri(){

    for(let key in this.params?.filters){

      const value = this.params?.filters[key];
      this.params.filters[key] = value.map(item => ({...item, checked: false}));
    }

  }

  onApplyFilter(){
    this.modalCtrl.dismiss(this.params);
  }

}
